import { createStackNavigator } from '@react-navigation/stack'
import { titleCase } from '../../comps/CustomHeader/headerFunctionHelpers'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { SearchTxns } from '../../screens/BillPayTransactions/SearchTxns'
import { screenTransition } from '../../util/common'
import { isSmallDevice } from '../../util/util'
import { Routes } from '../routes'

import BillPayments from '../../screens/BillPayments'
import AuthInput from '../../screens/BillPayments/AuthInput'
import BillFetch from '../../screens/BillPayments/BillFetch/'
import InstituteList from '../../screens/BillPayments/Education/InstituteList'
import SelectCity from '../../screens/BillPayments/Education/SelectCity'
import OperatorList from '../../screens/BillPayments/OperatorList/'
import BillPaymentDetails from '../../screens/BillPayments/PaymentDetails/'
import BillPayTransactionDetails from '../../screens/BillPayTransactionDetails/'
import BillPayTransactions from '../../screens/BillPayTransactions'

const BillPaymentsList = [
  {
    name: Routes.BILL_PAYMENTS,
    comp: BillPayments,
    title: 'Bill Payments',
    showHeader: true,
  },
  {
    name: Routes.OPERATOR_LIST,
    comp: OperatorList,
    title: 'Operator List',
    showHeader: true,
  },
  {
    name: Routes.BILL_FETCH,
    comp: BillFetch,
    title: 'Bill Fetch',
    showHeader: true,
  },
  {
    name: Routes.AUTH_INPUT,
    comp: AuthInput,
    title: 'AuthInput',
    showHeader: true,
  },
  {
    name: Routes.BILL_PAYMENTS_TRANSACTIONS,
    comp: BillPayTransactions,
    title: 'All Transactions',
    showHeader: true,
  },
  {
    name: Routes.BILLPAY_SEARCH,
    comp: SearchTxns,
    title: 'Search',
    showHeader: true,
  },
  {
    name: Routes.BILL_PAYMENTS_TRANSACTIONS_DETAILS,
    comp: BillPayTransactionDetails,
    title: 'Transaction Details',
    showHeader: true,
  },
  {
    name: Routes.BILL_PAYMENTS_DETAILS,
    comp: BillPaymentDetails,
    title: '',
    showHeader: false,
  },
  {
    name: Routes.SELECT_CITY,
    comp: SelectCity,
    title: 'Select City',
    showHeader: true,
  },
  {
    name: Routes.INSTITUTE_LIST,
    comp: InstituteList,
    title: '',
    showHeader: true,
  },
]

export const BillPaymentStack = (props: any) => {
  const { params } = props?.route

  const Stack = createStackNavigator()
  return (
    <Stack.Navigator
      screenOptions={{ headerBackTitleVisible: false, headerMode: 'screen', ...screenTransition }}
      initialRouteName={params?.initialRoute ?? Routes.BILL_PAYMENTS}>
      {BillPaymentsList?.map((item) => {
        return (
          <Stack.Screen
            key={item?.name}
            name={item?.name}
            component={item?.comp}
            options={
              isSmallDevice() && item.showHeader
                ? () => {
                    return {
                      headerLeft: () => <HeaderLeft />,
                      headerStyle: { borderBottomColor: 'rgba(0,0,0,0)' },
                      headerTintColor: '#fff',
                      headerBackVisible: true,
                      headerShadowVisible: false,
                      headerTransparent: true,
                      title: titleCase(item?.title ?? undefined),
                      headerTitleStyle: {
                        fontSize: 18,
                        lineHeight: 24,
                        fontFamily: 'JioType-Bold',
                      },
                    }
                  }
                : { headerShown: false }
            }
          />
        )
      })}
    </Stack.Navigator>
  )
}
